import Vue from 'vue'
import {Button,Image,Icon,Panel,Form,Field,Picker,Popup, Dialog} from 'vant';

Vue.use(Button)
Vue.use(Image)
Vue.use(Icon)
Vue.use(Panel)
Vue.use(Form)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Dialog)
